import { AppointmentType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/appointment_type.pb';

export const apptTypeColorFamilies = [
  ['#B72E2F', '#FF584C', '#FF837A', '#FFB8B3'], // reds
  ['#BF0D69', '#F358A8', '#F9A8D4', '#FBCFE8'], // pinks
  ['#963EAF', '#C467DE', '#D88EEC', '#E5AFF3'], // purples
  ['#4043F2', '#8788F8', '#A5B4FC', '#C7D2FE'], // blues
  ['#165FCC', '#3F8BFD', '#6BA6FF', '#9EC5FF'], // blues2
  ['#077169', '#018479', '#22CBC1', '#89E1DB'], // greens
  ['#0C6734', '#08873F', '#13C35F', '#95E4AA'], // greens2
  ['#845D0A', '#B88400', '#D39F03', '#F2BE04'], // yellows
  ['#A34900', '#F06F05', '#FDBA74', '#FED7AA'], // oranges
];

// Flattens the palette by color index across groups, so colors at the same index in each group are grouped together in the result.
export const appointmentTypePrimaryColorPalette = Array.from({ length: apptTypeColorFamilies[0].length }).flatMap(
  (_, i) => apptTypeColorFamilies.map((group) => group[i])
);

// Helper function to generate accessible color assignments based on visual distinguishability
export const generateAppTypeColorAssignments = (appointmentTypes: AppointmentType[]): Record<string, string> => {
  const assignments: Record<string, string> = {};

  const accessibleColorOrder: string[] = [];

  // This avoids darker colors initially and ensures even distribution
  // Priority order: index 1 (2nd), index 2 (3rd), index 3 (4th), index 0 (1st - darkest)
  const colorIndexOrder = [1, 2, 3, 0];

  colorIndexOrder.forEach((colorIndex) => {
    apptTypeColorFamilies.forEach((family) => {
      if (family[colorIndex]) {
        accessibleColorOrder.push(family[colorIndex]);
      }
    });
  });

  // Assign colors to appointment types
  appointmentTypes.forEach((appointmentType, index) => {
    // Use modulo to cycle through colors if there are more appointment types than colors
    const colorIndex = index % accessibleColorOrder.length;
    assignments[appointmentType.id] = accessibleColorOrder[colorIndex];
  });

  return assignments;
};
